/**
 * Demo Mode Badge Component
 * 
 * A reusable badge component that displays "Demo Mode" indicator
 * Used consistently across all page headers when a feature is in demo mode
 */

import React from 'react';

interface DemoModeBadgeProps {
  /** Optional className for custom styling */
  className?: string;
}

export function DemoModeBadge({ className = '' }: Readonly<DemoModeBadgeProps>): React.ReactElement {
  return (
    <span className={`px-3 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full ${className}`}>
      Demo Mode
    </span>
  );
}
